import * as React from 'react'
import { Component } from 'react'
import { Layout } from 'antd'
import SiderNav from './pages/main/siderNav'
import MainContent from './pages/main/mainContent'
import routes, { routes_ins_scanner, routes_ins_silizhu, routes_store_scanner, routes_store_silizhu } from './javascripts/routes'
import RouteWithSubRoutes from './pages/main/routeWithSubRoutes'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { RootState } from './core/reducers'
import { connect } from 'react-redux'
import './i18n'
import { LoginDevice } from './javascripts/public'

interface StateProps {
    routeKey: string
    appLoginStatus: boolean
    loginDevice: LoginDevice | string
}

type PropsType = RouteComponentProps & StateProps;
class App extends Component<PropsType> {

    renameTitle = () => {
        const { history } = this.props;
        let pathname = history.location.pathname;
        if(pathname.search('/institution/') !== -1) {
            document.title = 'SennoFeet足压后台-机构端';
        }
        if(pathname.search('/merchant/') !== -1) {
            document.title = 'SennoFeet足压后台-商户端';
        }
    }

    componentDidMount() {
        this.renameTitle();
        let { appLoginStatus, history, routeKey }= this.props;
        let loginStatus = localStorage.getItem('status');
        let location = history.location;
        let pathname = location.pathname;
        let authorized = false;
        routes.map((item) => {
            if(pathname === item.path && item.authorized) {
                authorized = true;
            }
        })
        if(!appLoginStatus && !loginStatus && authorized) {
            if(routeKey) {
                history.push(`/${routeKey}/login`);
            }
            else if(pathname.search('/institution') !== -1) {
                history.push(`/institution/login`);
            }
            else if(pathname.search('/merchant') !== -1) {
                history.push(`/merchant/login`);
            }
           
        }
    }

    componentDidUpdate(prevProps) {
        let { appLoginStatus, history, routeKey } = this.props;
        if(appLoginStatus !== prevProps.appLoginStatus) {
            if(!appLoginStatus) history.push(`/${routeKey}/login`);
        }
    }

    returnRouteAll = () => {
        const { loginDevice, routeKey } = this.props;
        let routesAll: any[] = routes;
        if (routeKey === "institution") {
            if (loginDevice === LoginDevice.SCANNER) {
                routesAll = [
                    ...routesAll,
                    ...routes_ins_scanner,
                ]
            }
            else {
                routesAll = [
                    ...routesAll,
                    ...routes_ins_silizhu,
                ]
            }
        }
        else if(routeKey === "merchant") {
            if (loginDevice === LoginDevice.SCANNER) {
                routesAll = [
                    ...routesAll,
                    ...routes_store_scanner,
                ]
            }
            else {
                routesAll = [
                    ...routesAll,
                    ...routes_store_silizhu,
                ]
            }
        }

        return routesAll;
    }

    render() {
        const { history } = this.props;
        let pathname = history.location.pathname;
        let home;
        let ua = navigator.userAgent.toLocaleLowerCase();
        let isMobile = /mobi/i.test(ua);

        let routesAll: any[] = this.returnRouteAll();

        routesAll.map((route) => {
            if(route.authorized && pathname.search(route.path) === 0) {
                home = (
                    <Layout>
                        {
                            !isMobile ? <SiderNav /> : null
                        }
                        <MainContent />
                    </Layout>
                )
            }
        })
        return (
            <div className="App">
                {routesAll.map((route, i) => {
                    if(!route.authorized) {
                        return <RouteWithSubRoutes key={i}{...route} />
                    }
                    else return null;
                })}
                {home}
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        appLoginStatus: state.user.loginStatus,
        routeKey: state.user.routeKey,
        loginDevice: state.user.loginDevice,
    }
}

export default withRouter(connect(mapStateToProps)(App))